import React from 'react'
import { FormikErrors } from 'formik'
import AlertTitle from '@material-ui/lab/AlertTitle'
import Alert from '@material-ui/lab/Alert'
import Constants from '../types/constants';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { PropertyDisplay } from '../display/PropertyDisplay';
import { Schema, SchemaDescription } from 'yup';

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        width: '600px'//contentMaxWidth,
    },
}))


type ErrorSummaryPropsType = {
    errors: FormikErrors<any>,
    title?: string,
    schema?: Schema<any>,
}
type LabelsType = {
    [name: string]: string
}
type SchemaDescriptionsFields = {
    [name: string]: SchemaDescription
}
const extractLabels = (errors: FormikErrors<any>, schema?: Schema<any>) => {
    const labels: LabelsType = {}
    Object.keys(errors).forEach(k => { labels[k] = k });
    if(schema) {
        const sd = schema.describe()
        const fields = sd.fields as SchemaDescriptionsFields
        Object.keys(labels).forEach(k => {labels[k] = fields[k] ? fields[k].label : k})
    }
    return labels;
}

const ErrorSummaryInModal = ({title, errors, schema}: ErrorSummaryPropsType) => {
    const labels = extractLabels(errors, schema)
    const classes = useStyles()
    return (
        <Alert severity='error' className={classes.root}>
            {title && <AlertTitle>{title}</AlertTitle>}
            {Object.keys(errors).map((k,i) => <PropertyDisplay key={k} label={labels[k]}>{errors[k]}</PropertyDisplay>)
            }
        </Alert>
    )
}

export default ErrorSummaryInModal;